import { Link } from 'react-router-dom'

export default function Forbidden() {
  return (
    <div className="error-page-canvas">
      <div className="error-page-card">
        <span className="error-page-code">403</span>
        <h1 className="error-page-title">Access Denied</h1>
        <p className="error-page-body">
          You don't have permission to view this resource.
        </p>
        <Link to="/investigations" className="error-page-link">
          ← Back to Investigations
        </Link>
      </div>
    </div>
  )
}
